import DeclinePhoneCall from './lib/decline_phone_call';
import RoutingEventType from 'models/routing_event/routing_event_type';

export default class DeclineWarmTransfer extends DeclinePhoneCall {
  _getRoutingEventType() {
    return RoutingEventType.DECLINED_WARM_TRANSFER;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/phone_call/decline_warm_transfer.js